/**
 * 统一的环境管理常量
 */

// 获取当前环境（Vite 使用 import.meta.env）
const NODE_ENV = import.meta.env.VITE_NODE_ENV || 'development'

export const IS_DEV = NODE_ENV === 'development'
export const IS_PROD = NODE_ENV === 'production'
export const IS_TEST = NODE_ENV === 'test'

/**
 * 调试信息输出 - 只有开发环境才显示
 */
export function debugLog(...args: unknown[]) {
	if (IS_DEV) {
		console.log('[DEBUG]', ...args)
	}
}

/**
 * 错误信息输出 - 只有开发环境才显示
 */
export function debugError(...args: unknown[]) {
	if (IS_DEV) {
		console.error('[ERROR]', ...args)
	}
}

/**
 * 警告信息输出 - 只有开发环境才显示
 */
export function debugWarn(...args: unknown[]) {
	if (IS_DEV) {
		console.warn('[WARN]', ...args)
	}
}
